export default function MicrosoftButton() {
    return (
        <div id="microsoftButton">
            <img id="microLogoImg" src="/images/microLogo.png" loading="lazy"/>
            Sign In With Microsoft
        </div>
    )
}